import React from 'react';
import CardHeader from '../shared/CardHeader';
import PollResults from './PollResults';
import PollAsk from './PollAsk';
import {connect} from 'react-redux';
import {loadPollById, vote} from 'state/poll/pollActions';
import {selectPollById, selectHasVoted} from 'state/poll/pollSelectors';
import {FormattedMessage} from 'react-intl';
import constantObject from 'utilities/constantObject';
import styles from './Poll.css?module';

const MODES = constantObject(['VOTE', 'RESULTS', 'PREVIEW']);

const showResultsOnVote = (prev, {hasVoted}) => ({
  mode: hasVoted ? MODES.RESULTS : prev.mode,
});

class PollContent extends React.Component {
  state = {
    mode: MODES.VOTE,
  };

  UNSAFE_componentWillMount() {
    this.setState(showResultsOnVote);
  }

  componentDidMount() {
    this.props.loadPollById(this.props.cardId);
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (this.props.hasVoted !== next.hasVoted) {
      this.setState(showResultsOnVote);
    }
  }

  handleShowResults = () => {
    this.setState({mode: MODES.PREVIEW});
  };

  handleHideResults = () => {
    this.setState({mode: MODES.VOTE});
  };

  handleVote = votes => {
    this.props.vote(this.props.cardId, votes);
    this.setState({mode: MODES.RESULTS});
  };

  render() {
    const {poll} = this.props;
    const {mode} = this.state;
    if (!poll) return null;

    return (
      <div>
        {mode === MODES.VOTE ? (
          <PollAsk
            poll={poll}
            canShowResults={poll.viewPollResultsBeforeVoting}
            onShowResults={this.handleShowResults}
            onVote={this.handleVote}
          />
        ) : (
          <PollResults
            canHideResults={mode === MODES.PREVIEW}
            onHideResults={this.handleHideResults}
            poll={poll}
          />
        )}
      </div>
    );
  }
}

const ConnectedPollContent = connect(
  (state, {cardId}) => ({
    poll: selectPollById(state, cardId),
    hasVoted: selectHasVoted(state, cardId),
  }),
  {
    vote,
    loadPollById,
  }
)(PollContent);

export const PollDetails = ({card, cardId, size}) => (
  <div className={styles.poll}>
    <div className={styles.creation}>
      <FormattedMessage
        id="Poll__Creation"
        description="Creation date of a poll card"
        defaultMessage="Created {date, date, medium}"
        values={{date: card.badgeUpdated}}
      />
    </div>
    <ConnectedPollContent cardId={cardId} card={card} size={size} />
  </div>
);

export const PollCard = ({card, cardId, size}) => (
  <div className={styles.poll}>
    <div className={styles.title}>
      <CardHeader card={card} />
    </div>
    <div className={styles.content}>
      <ConnectedPollContent cardId={cardId} size={size} />
    </div>
  </div>
);
